export default "__VITE_ASSET__7bb12460__"